"use client";

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import * as LucideIcons from "lucide-react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
function ServicesOverviewConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} className="h-64 rounded-xl bg-muted/10 animate-pulse" />)}
      </div>;
  }
  if (error || posts.length === 0) {
    return null;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {posts.map((post, i) => {
      const IconComponent = (LucideIcons as any)[post.customFields?.icon || "FileText"] || LucideIcons.FileText;
      return <div key={post.id} data-index={i}>
            <Card className="h-full border border-border shadow-soft transition-all duration-medium ease-smooth hover:shadow-strong hover:-translate-y-1 group">
              <CardHeader>
                <div className="mb-4 inline-flex items-center justify-center">
                  <IconComponent className="h-12 w-12 text-primary transition-colors duration-medium group-hover:text-secondary-dark" strokeWidth={1.5} />
                </div>
                <CardTitle className="text-xl text-foreground">
                  {post.title.rendered}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-base leading-relaxed text-muted-foreground">
                  {post.customFields?.description}
                </CardDescription>
              </CardContent>
            </Card>
          </div>;
    })}
    </div>;
}
export default function OurServicesOverview() {
  return <section id="our-services-overview" className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className="text-3xl font-display font-semibold tracking-tight text-foreground sm:text-4xl">
            Our Services Overview
          </h2>
          <p className="mt-4 text-lg text-muted-foreground max-w-2xl mx-auto">
            Comprehensive administrative support tailored for ABA and behavioral health providers
          </p>
        </div>

        <PostsProvider postType="service" wp_query={{
        per_page: 100
      }} fields={["id", "title.rendered", "link", "meta"]}>
          <ServicesOverviewConsumer />
        </PostsProvider>
      </div>
    </section>;
}